import { post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const downloadAssetImage = assetHierarchyId => post(`${url}/asset/image`, { assetHierarchyId });

const exp = {
  downloadAssetImage
};
export default exp;
